/* eslint-disable */
export default {
  _1_Days_of_the_Week: '1_Days_of_the_Week',
  _2_Answer_Questions_Correctly: '2_Answer_Questions_Correctly',
  _3_Drag_the_Days: '3_Drag_the_Days',
  _4_We_Got_the_Treasure: '4_We_Got_the_Treasure',
  _click: 'click',
  _Completed_Game: 'Completed_Game',
  _Correct_Answer: 'Correct_Answer',
  _drop_tile: 'drop_tile',
  _Five: 'Five',
  _Four: 'Four',
  _Friday: 'Friday',
  _Gold_Fall: 'Gold_Fall',
  _Incorrect_Answer: 'Incorrect_Answer',
  _Iris_Transition: 'Iris_Transition',
  _Jump_Land: 'Jump_Land',
  _Jungle_Theme: 'Jungle_Theme',
  _Monday: 'Monday',
  _One: 'One',
  _Question_1: 'Question_1',
  _Question_2: 'Question_2',
  _Question_3_1: 'Question_3_1',
  _Question_3_2: 'Question_3_2',
  _Question_4_1: 'Question_4_1',
  _Question_4_2: 'Question_4_2',
  _Question_5_1: 'Question_5_1',
  _Question_5_2: 'Question_5_2',
  _Question_6_1: 'Question_6_1',
  _Question_6_2: 'Question_6_2',
  _Question_7_1: 'Question_7_1',
  _Question_7_2: 'Question_7_2',
  _Saturday: 'Saturday',
  _Seven: 'Seven',
  _Six: 'Six',
  _Sunday: 'Sunday',
  _Temple_Theme: 'Temple_Theme',
  _Three: 'Three',
  _Thursday: 'Thursday',
  _Title_Screen_Jingle: 'Title_Screen_Jingle',
  _Tuesday: 'Tuesday',
  _Two: 'Two',
  _Wednesday: 'Wednesday',
}